/*
yogeshsrigiri 10/29/2022  2700912712  implemented breadcrumbs for all the side menu pages
Prakash 11/03/2022  2700912712  Added new card styles.
Prakash 11/23/2022  2700912712  Removed Card Component.
*/
import React, {useContext} from 'react';
import Tabs from './Tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';

const RuleGroup = ({setTabValue, groupId, RMbreCode}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <div className={`${classes.cardStyleWhite}`}>
        <Tabs groupId={groupId} RMbreCode={RMbreCode} setTabValue={setTabValue} />
      </div>
    </>
  );
};

export default RuleGroup;
